module.exports = __webpack_public_path__ + "static/media/footerIos.05014b0d.svg";